import styled from "styled-components";

export const NavbarBottomRounded = styled.div`
    border-top-left-radius: 0.8em;
    border-top-right-radius: 0.8em;
    overflow:hidden;
    box-shadow: 0 -0.125rem .25rem rgba(0,0,0,.075)!important;
    z-index:1030;
`;
